module.exports = __webpack_public_path__ + "static/media/desert-large-locked-disabled.6b6fab4e.png";